module.exports = __webpack_public_path__ + "media/images/icons/warning-alt-60191b682e7818ff101b7d38c9319645.png";